import { FC } from "react"
import { mediaFilter } from "../utils/image"

interface Props {
    src?: string
}

const ImgThumb: FC<Props> = ({ src }) => {

    if (!src) return null

    return (
        <img src={mediaFilter({path:src})} style={{
            width: 70,
            height: 70,
        }} />
    )
}

export default ImgThumb